import { cn } from '@/lib/utils';

type LogoProps = {
  /** `full` = mark + wordmark lockup (200:30). `mark` = square glyph only. */
  variant?: 'full' | 'mark';
  className?: string;
};

/**
 * Brand logo. The source asset is pure white on transparent, so it only reads
 * on dark surfaces — `invert dark:invert-0` flips it to ink in the light theme.
 */
export function Logo({ variant = 'full', className }: LogoProps) {
  const src = variant === 'full' ? '/enflux-logo.png' : '/enflux-mark.png';

  return (
    <img
      src={src}
      alt="Enflux"
      className={cn(
        'select-none invert dark:invert-0',
        variant === 'full' ? 'h-[22px] w-auto' : 'h-8 w-8',
        className
      )}
      draggable={false}
    />
  );
}
